import { Flex, ReactNode } from 'portal-commons';
import { FunctionComponent } from 'react';
import { faAddressBook } from '@fortawesome/pro-regular-svg-icons';
import { Grid, TextField } from '@material-ui/core';

import Section from '../../../../../shared_elements/components/Section';

interface BusinessContactDetailsSectionProps {
  email?: string;
  emailError?: string;
  onEmailChange?: (value: string) => void;
  onEmailBlur?: (value: string) => void;
  required: boolean;
  entityType: string;
}

const BusinessContactDetailsSection: FunctionComponent<
  BusinessContactDetailsSectionProps
> = ({
  email,
  emailError,
  onEmailChange,
  onEmailBlur,
  required,
  entityType,
}) => {
  return (
    <Section
      style={{ padding: '28px 35px 30px' }}
      icon={faAddressBook}
      title="Business Contact Details"
    >
      <Flex
        sx={{
          flexDirection: 'column',
          rowGap: '12px',
          width: '100%',
          marginTop: '4px',
        }}
      >
        <Flex
          sx={{
            flexDirection: 'column',
            rowGap: '4px',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '16px',
          }}
        >
          <div>
            {entityType === 'PUBLIC_PROFIT' ? (
              <>
                Brand's business contact will need to complete a Two-Factor
                Authentication (2FA) sent to their email address for brand
                verification.
              </>
            ) : (
              <>
                For certain vetting types, a brand business contact is required
                to respond to a Two-Factor Authentication email.
              </>
            )}
          </div>
          {required && <div>* Required Fields</div>}
        </Flex>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <div className="form-group-field">
              <TextField
                required={required}
                fullWidth
                error={!!emailError}
                value={email}
                label="Business Email Address"
                onChange={(event) => onEmailChange?.(event.target.value)}
                onBlur={(event) => onEmailBlur?.(event.target.value)}
              />
              {emailError ? <h6 className="error-msg">{emailError}</h6> : null}
            </div>
          </Grid>
        </Grid>
      </Flex>
    </Section>
  );
};

export default BusinessContactDetailsSection;
